import { createHook } from 'react-sweet-state';
import { EpicsStore } from '../main';
import type { State } from '../types';

export const useEpicsStoreActions = createHook(EpicsStore, {
	selector: null,
});

const getEpicsStoreIsInitialised = (state: State) => state.isInitialised;
export const useEpicsStoreIsInitialised = createHook(EpicsStore, {
	selector: getEpicsStoreIsInitialised,
});

export const getColumnCounts = (state: State) => state.columnCounts;
export const useColumnCounts = createHook(EpicsStore, {
	selector: getColumnCounts,
});

export const getEpicIssueType = (state: State) => state.epicIssueType;
export const useEpicIssueType = createHook(EpicsStore, {
	selector: getEpicIssueType,
});

export const getEpicIssueTypeName = (state: State) => state.epicIssueTypeName;
export const useEpicIssueTypeName = createHook(EpicsStore, {
	selector: getEpicIssueTypeName,
});

export const getTimeTrackingOptions = (state: State) => state.timeTrackingOptions;
export const useTimeTrackingOptions = createHook(EpicsStore, {
	selector: getTimeTrackingOptions,
});

export const getIsRankingEnabled = (state: State) => state.isRankingEnabled;
export const useIsRankingEnabled = createHook(EpicsStore, {
	selector: getIsRankingEnabled,
});

export const getEpicCardsState = (state: State) => ({
	cards: state.cards,
	loading: state.loading,
	error: state.error,
	refetchError: state.refetchError,
});
export const useEpicCardsState = createHook(EpicsStore, {
	selector: getEpicCardsState,
});

/* -------------- These selectors are used for the backlog epic filter -------------- */
export const getEpicsFilterData = (state: State) => ({
	cards: state.cards,
	epicIssueTypeName: state.epicIssueTypeName,
	isEpicIssueTypeAvailable: state.isEpicIssueTypeAvailable,
});
export const useEpicsFilterData = createHook(EpicsStore, {
	selector: getEpicsFilterData,
});

export const getEpicIssueTypeAvailable = (state: State) => state.isEpicIssueTypeAvailable;
export const useEpicIssueTypeAvailable = createHook(EpicsStore, {
	selector: getEpicIssueTypeAvailable,
});
